import { isDefined } from "@bps/common-utils";
import { DATE_FORMATS } from "@bps/date-time";
import {
  dataAttribute,
  DataAttributes,
  noWrap,
  Option,
  Persona,
  PersonaSize,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { AddressDto } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

import { getContactSuggestionItem } from "./getContactSuggestionItem.tsx";

export const ContactPickerSuggestionItem = (props: {
  option: Option<Contact>;
  context: {
    searchBy?: "name" | "phoneNumber";
    searchValue?: string;
    inUse?: boolean;
  };
}) => {
  const { option, context } = props;

  const theme = useTheme();

  if (!option.data) return null;

  const item = getContactSuggestionItem(option.data, theme, {
    isSelected: true
  });

  const getNumberOrAddress = () => {
    if (context.searchBy === "phoneNumber") {
      if (context && isDefined(context.searchValue)) {
        const phone = option.data?.phoneCommunicationsOnly.find(x =>
          x.value.includes(context.searchValue!)
        );
        if (phone) {
          return phone.value;
        }
      }
      return option.data?.phone;
    } else {
      const address: AddressDto | undefined =
        option.data?.physicalAddress ?? option.data?.postalAddress;

      return address && address.suburb;
    }
  };

  return (
    <Stack horizontal className={item.className}>
      <Stack
        horizontal
        tokens={{ childrenGap: 8 }}
        styles={{ root: { height: 36, ...noWrap } }}
      >
        <Persona
          id={option.data?.id}
          size={PersonaSize.size24}
          imageInitials={option.data?.initials}
          styles={{ root: { flex: 0, alignSelf: "center" } }}
        />
        <Stack styles={{ root: { minWidth: 0 } }}>
          <Text styles={{ root: { ...noWrap } }}>
            {option.data?.reversedName} {context.inUse && "(in use)"}
          </Text>
          <Stack horizontal tokens={{ childrenGap: 16 }}>
            {option.data?.isPatient && (
              <Text
                variant="small"
                {...dataAttribute(
                  DataAttributes.Element,
                  "persona-option-birthday"
                )}
              >
                {option.data?.birthDate
                  ? option.data?.birthDate.toFormat(
                      DATE_FORMATS.DAY_DEFAULT_FORMAT
                    )
                  : "No DOB rec."}
              </Text>
            )}
            <Text
              variant="small"
              {...dataAttribute(
                DataAttributes.Element,
                "persona-option-address"
              )}
            >
              {getNumberOrAddress()}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
